import React, { useState } from "react";
// react component for creating dynamic tables
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
//import ReactBSAlert from "react-bootstrap-sweetalert";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";
// @material-ui/core components
import DatePicker from "react-datepicker";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
// @material-ui/lab components
// @material-ui/icons components
// core components
import Snackbar from "components/Snackbar/Snackbar.js";
import componentStyles from "assets/theme/views/admin/react-bs-table.js";
import btnComponentStyles from "assets/theme/components/button.js";
import LoadingAnimation from "components/Animations/loading";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import { useAsyncEffect } from "use-async-effect";
// import dateFormat from "dateformat";
import {
  //getLaundryOrders,
  getAllActiveServices,
  getSortedLaundryOrdersByLaundry,
  getAllLaundryOrdersByLaundryIdWithCompensation,
} from "../../network/ApiAxios";
import {
  redirectToLogout,
  //parseWashingFeatures,
  zeroFill,
  numericSortFunc,
  getIsPickedFromLaundry
}
  from "common/SharedFn";
import { Receipt, ArrowBack } from "@material-ui/icons";
import { useHistory } from "react-router-dom";
//import { Table } from "@material-ui/core";

const useStyles = makeStyles(componentStyles);
const useStylesButtons = makeStyles(btnComponentStyles);
const createHistory = require("history").createBrowserHistory;

const pagination = paginationFactory({
  page: 1,
  alwaysShowAllBtns: true,
  showTotal: true,
  withFirstAndLast: false,
  sizePerPage: 50,
  sizePerPageRenderer: ({ onSizePerPageChange }) => (
    <div className="dataTables_length" id="datatable-basic_length">
      <label>
        Show{" "}
        {
          <select
            name="datatable-basic_length"
            aria-controls="datatable-basic"
            className="form-control form-control-sm"
            onChange={(e) => onSizePerPageChange(e.target.value)}
          >
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="500">500</option>
            <option value="1000">1000</option>
          </select>
        }{" "}
        entries.
      </label>
    </div>
  ),
});

const { SearchBar } = Search;

const { ExportCSVButton } = CSVExport;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const LaundryOrdersViewTable = (props) => {
  const classes = { ...useStyles(), ...useStylesButtons() };
  const [alert, setAlert] = React.useState(false);
  const componentRef = React.useRef(null);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState("");
  const [notifMessage, setNotifMessage] = useState("");
  const [success, setSuccess] = React.useState(false);
  const [showError, setShowError] = React.useState(false);
  const [filterBy, setFilterBy] = useState(0);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [id, setId] = useState();
  const [forceRefresh, setForceRefresh] = useState(false);
  const [ids, setIds] = useState([]);
  const [servicesList, setServicesList] = useState([]);
  const [selectedCount, setSelectedCount] = useState(0);
  const [tableSize, setTableSize] = useState(0);
  const [orders, setOrders] = useState([]);
  const [compensationDialogOpen, setCompensationDialogOpen] = useState(false);
  const [compensationStartDate, setCompensationStartDate] = useState(new Date());
  const [compensationEndDate, setCompensationEndDate] = useState(new Date());
  const [isDownloadingReport, setIsDownloadingReport] = useState(false);
  var columns = [];
  var currentLaundryId = props.match.params.id;
  let history = useHistory();

  const rowStyle = (row, rowIndex) => {
    if ((row.notes != null && row.notes != "") || (row.userLevelNotes != null && row.userLevelNotes != "")) {
      return { backgroundColor: "#FFCCCB" };
    }
    return {};
  };

  const selectRow = {
    mode: "checkbox",
    clickToSelect: true,
    style: { backgroundColor: "#c8e6c9" },
    onSelect: (row, isSelect, rowIndex, e) => {
      if (isSelect) {
        ids.push(row.id);
      } else {
        var index = ids.indexOf(row.id);
        if (index !== -1) {
          ids.splice(index, 1);
        }
      }
      setSelectedCount(ids.length);
    },
    onSelectAll: (isSelect, rows, e) => {
      if (isSelect) {
        for (var i = 0; i < rows.length; i++) {
          ids.push(rows[i].id);
        }
      } else {
        for (var i = 0; i < rows.length; i++) {
          var index = ids.indexOf(rows[i].id);
          if (index !== -1) {
            ids.splice(index, 1);
          }
        }
      }
      setSelectedCount(ids.length);
    },
  };

  const showSuccessNotification = (message) => {
    setNotifMessage(message);
    setSuccess(true);
    setTimeout(function () {
      setSuccess(false);
    }, 3000);
  };

  const showErrorNotification = (message) => {
    setNotifMessage(message);
    setShowError(true);
    setTimeout(function () {
      setShowError(false);
    }, 3000);
  };

  const accessOrderPage = (id) => {
    let history = createHistory();
    history.push("/admin/laundryOrdersView/laundryOrder/" + id);
    let pathUrl = window.location.href;
    window.location.href = pathUrl;
  };


  const clearCurrentRecord = () => {
    setId();
  };

  const handleCompensationReportDownload = async () => {
    setIsDownloadingReport(true);
    try {
      const response = await getAllLaundryOrdersByLaundryIdWithCompensation(
        compensationStartDate,
        compensationEndDate,
        currentLaundryId
      );

      const compensationData = response.data?.data;

      if (!compensationData || compensationData.length === 0) {
        showErrorNotification("No compensation data found.");
        return;
      }

      // Build CSV content
      const csvRows = ["Order ID, Rewash, Dropoff Date, Dropoff Timeslot, Washed Date, Washed Time, Final Price, Compensation Amount, Overload"];
      compensationData.forEach(item => {
        const dropoffDate = new Date(item.dropoffDate);
        const formattedDate = `${dropoffDate.getDate()}-${dropoffDate.toLocaleString('en-US', { month: 'short' })}-${String(dropoffDate.getFullYear()).slice(-2)}`;
        const compensationAmount = item.compensationAmount === null || item.compensationAmount === undefined
    ? ''
    : item.compensationAmount;
    const overload = item.overload ? "YES" : "";
    const isRewash = item.rewash ? "YES" : "";
    const washedDatetime = item.washedDatetime;
        const washedDate = new Date(washedDatetime);
        const washedDateFormatted = `${washedDate.getDate()}-${washedDate.toLocaleString('en-US', { month: 'short' })}-${String(washedDate.getFullYear()).slice(-2)}`;
        const bahrainTime = new Date(washedDate.toLocaleString("en-US", { timeZone: "Asia/Bahrain" }));
        const washedTime = `${String(bahrainTime.getHours()).padStart(2, '0')}:${String(bahrainTime.getMinutes()).padStart(2, '0')}`;
        csvRows.push(`${item.orderId}, ${isRewash}, ${formattedDate}, ${item.dropoffTimeslot}, ${washedDateFormatted},${washedTime},${item.finalPrice},${compensationAmount},${overload}`);
      });

      const csvString = csvRows.join("\n");
      const blob = new Blob([csvString], { type: "text/csv" });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      const filename = `compensation_report_${compensationStartDate.toISOString().split("T")[0]}_${compensationEndDate.toISOString().split("T")[0]}.csv`;

      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      setCompensationDialogOpen(false);
      showSuccessNotification("Compensation report downloaded successfully!");
    } catch (error) {
      console.error("Error downloading CSV:", error);
      showErrorNotification("Failed to download compensation report.");
    } finally {
      setIsDownloadingReport(false);
    }
  };



  const fetchOrders = async () => {
    setForceRefresh(false);
    setIsLoading(true);
    setData([]);
    try {
      const response = await getSortedLaundryOrdersByLaundry(endDate, currentLaundryId);
      const responseServicesList = await getAllActiveServices();
      const { data } = response;
      if (data.result.isSuccess) {
        setServicesList(responseServicesList.data.data);
        setData(data.data.orders);
        setTableSize(data.data.orders.length);
        setOrders(data.data.orders);
        //setError("");
      } else {
        showErrorNotification(data.result.description);
        if (data.result.code == -2) {
          redirectToLogout();
        }
      }
    } catch (ex) {
      showErrorNotification("Failed to fetch orders " + ex);
    }
    setIsLoading(false);
  };

  useAsyncEffect(async () => {
    if (endDate == null) {
      setEndDate(new Date());
    }
    if (endDate != null) {
      fetchOrders();
    }

  }, [
    forceRefresh,
    endDate
  ]);


  const getOrderColumns = () => {
    columns = [
      {
        dataField: "idForm",
        text: "ID",
        sort: true,
      },
      {
        dataField: "userIdForm",
        text: "User ID",
        sort: true,
      },
      // {
      //   dataField: "pickupTimeslot",
      //   text: "Customer Pickup DateTime",
      //   sort: true,
      //   csvExport: true,
      //   sortFunc: slotDateSortFunc,
      // },

    ];
    if (servicesList.length > 0) {
      servicesList.sort(function (a, b) {
        var x = a.nameEn.toLowerCase();
        var y = b.nameEn.toLowerCase();
        return x < y ? -1 : x > y ? 1 : 0;
      });
    }
    for (var j = 0; j < servicesList.length; j++) {
      if (servicesList[j].isPerItem === 0) {
        columns.push({
          dataField: servicesList[j].nameEn + "Q",
          text: servicesList[j].nameEn.replaceAll("doobi ", ""),
          sort: true,
          sortFunc: numericSortFunc
        });
      }
    }
    orderColumns.push({
      dataField: "totalPerItem",
      text: "Total Bags",
      sort: true,
      sortFunc: numericSortFunc
    },
      {
        dataField: "statusTextByStatus.textEn",
        text: "Status",
        sort: true,
      },
      {
        dataField: "isPickedFromLaundry",
        text: "Picked from Laundry",
        sort: true,
      },
      {
        dataField: "actions",
        text: "Actions",
        csvExport: false,
      },);
    columns.push({
      dataField: "totalPerItem",
      text: "Per Item Count",
      sort: true,
      sortFunc: numericSortFunc
    },
      {
        dataField: "statusTextByStatus.textEn",
        text: "Status",
        sort: true,
      },
      {
        dataField: "isPickedFromLaundry",
        text: "Picked from Laundry",
        sort: true,
      },
      {
        dataField: "actions",
        text: "Actions",
        csvExport: false,
      },
    );
  }

  const orderColumns = [{
    dataField: 'publicId',
    text: 'Order ID'
  }, {
    dataField: 'totalWeightPerOrder',
    text: 'Weight (KG)'
  }];

  const makeTableForOrder = (info) => {
    if (info) {
      for (var j = 0; j < servicesList.length; j++) {
        info[servicesList[j].nameEn + "Q"] = 0;
      }
      info.totalBags = 0;
      info.totalPerItem = 0;
      for (var i = 0; i < info.qrTagsById.length; i++) {
        if (info.qrTagsById[i].flow == 0) {
          info.totalPerItem++;
        }
      }
      //info.totalPerItem = info.qrTagsById.length;
      info.totalWeightPerOrder = 0;
      for (var i = 0; i < info.qrTagsById.length; i++) {
        info.totalWeightPerOrder += info.qrTagsById[i].weight;
      }
      info.totalWeightPerOrder = info.totalWeightPerOrder.toFixed(2);
      info.isPickedFromLaundry = getIsPickedFromLaundry(info) ? "Yes" : "No";
      info.actions = <div className="actions-right">
        <Tooltip title="View Details">
          <Button
            size="small"
            color="primary"
            variant="contained"
            onClick={() => {
              accessOrderPage(info.id);
            }}
          >
            <Box component={Receipt} />
          </Button>
        </Tooltip>
      </div>;
    }

    return {
      ...info,
      idForm: (
        info.publicId
      ),
      userIdForm: (
        "C" + zeroFill(info.userId, 5)
      ),
      pickupTimeslot:
        info.pickupDateText +
        " " +
        info.availabilitySlotByPickupTimeslot?.startTime +
        " - " +
        info.availabilitySlotByPickupTimeslot?.endTime,
      dropoffTimeslot:
        info.dropoffDateText +
        " " +
        info.availabilitySlotByDropoffTimeslot?.startTime +
        " - " +
        info.availabilitySlotByDropoffTimeslot?.endTime,
      actions: (
        <div className="actions-right">
          <Tooltip title="View Details">
            <Button
              size="small"
              color="primary"
              variant="contained"
              onClick={() => {
                accessOrderPage(info.id);
              }}
            >
              <Box component={Receipt} />
            </Button>
          </Tooltip>
        </div>
      ),
    };
  };

  const resultToRender = orders.map((order, index) => (
    <div key={index}>
      <div style={{ "display": "flex", "justifyContent": "space-between" }}>
        <div>
          <h3>Ready before {order.startTime}</h3>
        </div>
        <div>
          <h3>Total Orders: {order.orders.length}</h3>
        </div>
        <div>
          <h3>Total Weight: {(Math.round(order.totalWeight * 1000) / 1000)}Kg</h3>
        </div>
      </div>
      {/* <BootstrapTable keyField='id' data={ order.orders } columns={ orderColumns } /> */}
      {/* {makeTableRow(order.orders)} */}
      {
        order.orders.length > 0 ? order.orders.map((info) => { makeTableForOrder(info) }) : ''
      }
      <BootstrapTable
        keyField='id'
        data={order.orders}
        bootstrap4={true}
        bordered={true}
        striped={true}
        columns={orderColumns}
        rowStyle={rowStyle}
        noDataIndication={() =>
          isLoading ? (
            <Box
              component={Grid}
              container
              justifyContent="center"
              className="justify-content-center"
            >
              <div
                className="text-center"
                style={{ width: "20%" }}
              >
                <LoadingAnimation />{" "}
              </div>
            </Box>
          ) : (
            <h4>No Records</h4>
          )
        }
        id="main-table"
      />
    </div>
  ));




  const makeTableRow = (info) => {
    //info = parseWashingFeatures(info);

    return {
      ...info,
      idForm: (
        info.publicId
      ),
      userIdForm: (
        "C" + zeroFill(info.userId, 5)
      ),
      pickupTimeslot:
        info.pickupDateText +
        " " +
        info.availabilitySlotByPickupTimeslot.startTime +
        " - " +
        info.availabilitySlotByPickupTimeslot.endTime,
      dropoffTimeslot:
        info.dropoffDateText +
        " " +
        info.availabilitySlotByDropoffTimeslot.startTime +
        " - " +
        info.availabilitySlotByDropoffTimeslot.endTime,
      actions: (
        <div className="actions-right">
          <Tooltip title="View Details">
            <Button
              size="small"
              color="primary"
              variant="contained"
              onClick={() => {
                accessOrderPage(info.id);
              }}
            >
              <Box component={Receipt} />
            </Button>
          </Tooltip>
        </div>
      ),
    };
  };

  return (
    <>
      {alert}
      {getOrderColumns()}
      {/* Page content */}
      <Container
        maxWidth={false}
        component={Box}
        marginTop="-4.5rem"
        classes={{ root: classes.containerRoot }}
      >
        <Grid container>
          <Grid item xs={12}>
            <Card elevation={0}>
              <CardHeader
                subheader={
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Tooltip title="Back">
                      <Button
                        size="small"
                        classes={{
                          root: classes.buttonContainedPrimary,
                        }}
                        variant="contained"
                        style={{ marginRight: "10px" }}
                        onClick={() => {
                          history.goBack();
                        }}
                      >
                        <Box component={ArrowBack} />
                      </Button>
                    </Tooltip>
                    <Box
                      component={Typography}
                      variant="h2"
                      marginBottom="0!important"
                    >
                      <Box component="span">Laundry Orders</Box>
                    </Box>

                    <Tooltip title="Download Compensation Report">
                      <Button
                        size="small"
                        classes={{
                          root: classes.buttonContainedSuccess,
                        }}
                        variant="contained"
                        style={{ marginLeft: "10px" }}
                        onClick={() => setCompensationDialogOpen(true)}
                      >
                        <Box component={Receipt} />
                        Compensation Report
                      </Button>
                    </Tooltip>
                  </div>
                }
                classes={{ root: classes.cardHeaderRoot }}
              ></CardHeader>
              <ToolkitProvider
                data={data}
                keyField="id"
                columns={columns}
                search
                exportCSV
              >
                {(props) => (
                  <div className="py-4 table-responsive">
                    <Grid container className="pl-4">
                      <Grid item xs={12} sm={6}>

                        {/* <Tooltip
                          title="This will copy to your download the table content."
                          style={{ margin: "5px" }}
                        > */}
                        <ExportCSVButton
                          className="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedSizeSmall MuiButton-sizeSmall"
                          {...props.csvProps}
                        >
                          <span className="MuiButton-label buttonContainedSuccess,">Download</span>
                        </ExportCSVButton>
                        {/* </Tooltip> */}
                        <div style={{ display: "inline-block" }}>
                          <DatePicker
                            timeCaption="End Date"
                            selected={endDate}
                            customInput={<OutlinedInput />}
                            onChange={(date) => {
                              localStorage.setItem("searchEndDate", date);
                              setEndDate(date);
                            }}
                            dateFormat="dd-MM-yyyy"
                          />
                        </div>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <div
                          id="datatable-basic_filter"
                          className="dataTables_filter px-4 pb-1 float-right"
                        >
                          <label>
                            Search:
                            <SearchBar
                              className="form-control-sm"
                              placeholder=""
                              {...props.searchProps}
                            />
                          </label>
                        </div>
                      </Grid>
                    </Grid>

                    {/* <Grid container className="pl-4">
                      <Grid item xs={12} sm={12}>
                        <div
                            style={{
                              marginBottom: "20px",
                            }}
                          >
                        {selectedCount} Orders Selected
                        </div>
                      </Grid>
                    </Grid> */}

                    <Grid>
                      {
                        orders.length > 0 ? resultToRender : <BootstrapTable
                          keyField='id'
                          data={orders}
                          bootstrap4={true}
                          bordered={true}
                          striped={true}
                          columns={orderColumns}
                          rowStyle={rowStyle}
                          noDataIndication={() =>
                            isLoading ? (
                              <Box
                                component={Grid}
                                container
                                justifyContent="center"
                                className="justify-content-center"
                              >
                                <div
                                  className="text-center"
                                  style={{ width: "20%" }}
                                >
                                  <LoadingAnimation />{" "}
                                </div>
                              </Box>
                            ) : (
                              <div>
                                <h4>No Records</h4>
                              </div>
                            )
                          }
                          id="main-table"
                        />
                      }
                    </Grid>
                    {/* <BootstrapTable
                      ref={componentRef}
                      {...props.baseProps}
                      bootstrap4={true}
                      pagination={pagination}
                      bordered={true}
                      striped={true}
                      // selectRow={selectRow}
                      noDataIndication={() =>
                        isLoading ? (
                          <Box
                            component={Grid}
                            container
                            justifyContent="center"
                            className="justify-content-center"
                          >
                            <div
                              className="text-center"
                              style={{ width: "20%" }}
                            >
                              <LoadingAnimation />{" "}
                            </div>
                          </Box>
                        ) : (
                          <h4>No Records</h4>
                        )
                      }
                      id="main-table"
                    /> */}
                  </div>
                )}
              </ToolkitProvider>
            </Card>
          </Grid>
        </Grid>


        <Snackbar
          place="tr"
          color="success"
          // icon={AddAlert}
          message={notifMessage}
          open={success}
          closeNotification={() => setSuccess(false)}
          close
        />

        <Snackbar
          place="tr"
          color="rose"
          // icon={AddAlert}
          message={notifMessage}
          open={showError}
          closeNotification={() => setShowError(false)}
          close
        />

        {/* Compensation Report Dialog */}
        <Dialog
          open={compensationDialogOpen}
          onClose={() => setCompensationDialogOpen(false)}
          TransitionComponent={Transition}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            style: {
              maxHeight: '80vh',
              overflow: 'visible'
            }
          }}
        >
          <DialogTitle>
            <Typography variant="h4" component="div" style={{ fontWeight: 'bold', fontSize: '1rem' }}>
              Download Compensation Report
            </Typography>
          </DialogTitle>
          <DialogContent style={{ overflow: 'visible' }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" gutterBottom>
                  Start Date
                </Typography>
                <div style={{ position: 'relative' }}>
                  <DatePicker
                    selected={compensationStartDate}
                    onChange={(date) => setCompensationStartDate(date)}
                    customInput={<OutlinedInput fullWidth />}
                    dateFormat="dd-MM-yyyy"
                    maxDate={compensationEndDate}
                    popperPlacement="bottom-start"
                    popperModifiers={{
                      preventOverflow: {
                        enabled: true,
                        escapeWithReference: false,
                        boundariesElement: 'viewport'
                      }
                    }}
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" gutterBottom>
                  End Date
                </Typography>
                <div style={{ position: 'relative' }}>
                  <DatePicker
                    selected={compensationEndDate}
                    onChange={(date) => setCompensationEndDate(date)}
                    customInput={<OutlinedInput fullWidth />}
                    dateFormat="dd-MM-yyyy"
                    minDate={compensationStartDate}
                    maxDate={new Date()}
                    popperPlacement="bottom-start"
                    popperModifiers={{
                      preventOverflow: {
                        enabled: true,
                        escapeWithReference: false,
                        boundariesElement: 'viewport'
                      }
                    }}
                  />
                </div>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setCompensationDialogOpen(false)}
              color="primary"
            >
              Cancel
            </Button>
            <Button
              onClick={handleCompensationReportDownload}
              color="primary"
              variant="contained"
              disabled={isDownloadingReport}
              classes={{
                root: classes.buttonContainedSuccess,
              }}
            >
              {isDownloadingReport ? "Downloading..." : "Download Report"}
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </>
  );
};

export default LaundryOrdersViewTable;
